import { _eventBus } from "../../core/events/EventBus";
import { getCmsHomeBannerListAction } from "../../Actions/LogicActions/CmsHomePageBanner/GetCmsHomeBannerListAction";
import { getCmsNewsListAction } from "../../Actions/LogicActions/CMSNews/GetCMSNewsList";
import { getPopularTripsAction } from "../../Actions/LogicActions/Search/GetPopularTripsAction";
import { getCMSEnhancedTripsAction } from "../../Actions/LogicActions/CMSEnhancedTrips/GetCMSEnhancedTripsAction";
import { getCmsDestinationsAction } from "../../Actions/LogicActions/CmsDestination/GetCmsDestinationsActon";
import { getCmsRoutesAction } from "../../Actions/LogicActions/Search/GetCmsRoutesActions";
import { getCmsStopsListAction } from "../../Actions/LogicActions/Search/GetCmsStopsListAction";
import { getCmsUsefulInformationAction } from "../../Actions/LogicActions/Search/GetUsefulInformationAction";

/**
 * Stale-while-revalidate display refresh.
 *
 * cmsApiRequest serves expired-but-recent cache instantly and revalidates in
 * the background; when the fresh payload differs it emits CMS_CONTENT_REFRESHED
 * with the endpoint. Each entry below maps an endpoint fragment to the
 * self-applying action singleton that owns that content's atoms. Re-executing
 * the action reads the now-fresh cache (no extra network) and re-sets its
 * atoms, so the widgets update in place.
 *
 * Endpoints without an entry still refresh the cache — their widgets simply
 * show the new content on the next page view.
 */
const REFRESHERS: ReadonlyArray<[fragment: string, action: { execute: () => Promise<void> }]> = [
    ["/home-banners", getCmsHomeBannerListAction],
    ["/news-articles", getCmsNewsListAction],
    ["/popular-trips", getPopularTripsAction],
    ["/enhance-trips", getCMSEnhancedTripsAction],
    ["/cities", getCmsDestinationsAction],
    ["/routes", getCmsRoutesAction],
    ["/helps-and-useful-information", getCmsUsefulInformationAction],
    ["/stops", getCmsStopsListAction],
];

export const initCmsStaleRefresh = () => {
    const sub = _eventBus.on<{ endpoint: string }, void>({
        eventName: "CMS_CONTENT_REFRESHED",
        handler: ({ data }) => {
            const endpoint = data?.endpoint || "";
            const match = REFRESHERS.find(([fragment]) => endpoint.includes(fragment));
            if (match) void match[1].execute().catch(() => { /* stale stays visible; refreshed next view */ });
        },
    });
    return () => sub.off();
};
